export default __webpack_public_path__ + "26419f302ea834a91563c12a713b7857.png";